//to be changed after availing exact live URL and after changes
const socketUATURL = "wss://ndst.nuvamawealth.com";
// const socketUATURL: string = "wss://vamauat.nuvamawealth.com";
const socketLIVEURL = "wss://ndst.nuvamawealth.com";
//const socketLIVEURL: string = "wss://tx3stream.edelweiss.in";
//const socketLIVEURL: string = "wss://ndst.nuvamawealth.com";
const LivePort = 9663;
const UATPort = 9663;
// const UATPort = 8443;
// Assign object to a variable before exporting as module default  import/no-anonymous-default-export
const socketConfig = {
    socketURL: process.env.NODE_ENV === "production" || process.env.NODE_ENV === "cug"
        ? socketLIVEURL
        : socketUATURL,
    port: process.env.NODE_ENV === "production" || process.env.NODE_ENV === "cug"
        ? LivePort
        : UATPort,
};
export default socketConfig;
